import React from "react";
import {mergeProperties} from "../components/Utility";


export const getFormData = (data) => {
    const initialData = {
        name: '',
        unit: '',
        status: '1',
        stock: '',
        tags: '',
        additionalDetails: {
            isVeg: true
        },
        description: '',
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getTableColumns = ({ActionDropdown}) => {
    let tableColumns = [
        {header: "Name", field: "name"},
        {header: "Unit", field: "unit"},
        {header: "Tags", field: "tags"},
    ];

    tableColumns.push({
        header: 'Action',
        disableSorting: true,
        field: 'action',
        align: "right",
        render: (row) => {
            return <ActionDropdown row={row} view={true}/>;
        },
    });

    return tableColumns;
};

export const getTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map(item => ({
        id: item.id,
        name: item.name,
        unit: item.unit,
        tags: item?.tags.map(tag => tag.name).join(", "),
    }));
}

export const getDetailData = ({item}) => {
    if (!item) return {details: {}};
    return {
        details: {
            name: item?.name,
            unit: item?.unit,
            stock: item?.stock,
            availability: item?.availability ? "Yes" : "No",
            status: item.status ? "Active" : "Inactive",
            isVeg: item?.isVeg ? "Yes" : "No",
            tags: item?.tags.map(tag => tag.name).join(", "),
            description: item?.description
        }
    };
}
